module.exports = __webpack_public_path__ + "img/unlock.607b1f77.svg";